export default __webpack_public_path__ + "static/media/PlusWhite.c36602af.svg";